import React from 'react';
import { Button, Stack } from '@grubhubprod/gh-cookbook-react';

export interface ContactButtonProps {
  text: React.ReactNode;
  href: string;
  variant?: 'primary' | 'secondary';
}

export const ContactButton: React.FC<ContactButtonProps> = ({
  text,
  href,
  variant = 'primary',
}) => (
  <Button
    variant={variant}
    buttonSize="medium"
    block
    target="_blank"
    as="a"
    href={href}
  >
    <Stack y="xxx-sm">{text}</Stack>
  </Button>
);
